import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import WorkspaceLayout from './components/layout/WorkspaceLayout';
import AllInventory from './pages/AllInventory';
import Chats from './pages/Chats';
import Comments from './pages/Comments';
import Campaigns from './pages/Campaigns';
import ShopifyApp from './pages/ShopifyApp';
import Users from './pages/Users';
import PlatformLogin from './pages/PlatformLogin';
import MasterAdmin from './pages/MasterAdmin';
import UserLogin from './pages/UserLogin';
import WorkspacePicker from './pages/WorkspacePicker';
import WhatsAppTemplates from './pages/WhatsAppTemplates';
import AutomationEditor from './pages/AutomationEditor';
import Dashboard from './pages/Dashboard';
import Automations from './pages/Automations';
import Integrations from './pages/Integrations';
import Tags from './pages/Tags';
import Notifications from './pages/Notifications';
import Tickets from './pages/Tickets';
import WebsiteChat from './pages/WebsiteChat';
import AiAgents from './pages/AiAgents';
import Orders from './pages/Orders';
import { RequirePage, RequireAnyPage } from './context/PermissionsContext';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<UserLogin />} />
        <Route path="/select-workspace" element={<WorkspacePicker />} />
        <Route path="/add-workspaces" element={<PlatformLogin />} />
        <Route path="/add-workspaces/dashboard" element={<MasterAdmin />} />
        <Route path="/chat/:workspaceUuid" element={<WebsiteChat />} />
        <Route path="/chat/:workspaceUuid/embed" element={<WebsiteChat />} />
        <Route path="/chat/:workspaceUuid/users/:visitorId" element={<WebsiteChat />} />
        <Route path="/chat/:workspaceUuid/users/:visitorId/embed" element={<WebsiteChat />} />
        <Route path="/workspace/:workspaceUuid/automations/:automationId" element={<AutomationEditor />} />
        <Route path="/workspace/:workspaceUuid" element={<WorkspaceLayout />}>
          <Route path="all-inventory" element={<AllInventory />} />
          <Route path="dashboard" element={<RequirePage page="dashboard"><Dashboard /></RequirePage>} />
          <Route path="chats" element={<RequirePage page="chats"><Chats /></RequirePage>} />
          <Route path="chats/comments" element={<RequirePage page="chats"><Comments /></RequirePage>} />
          <Route path="chats/:platform/:chatId?" element={<RequirePage page="chats"><Chats /></RequirePage>} />
          <Route path="users" element={<RequirePage page="team"><Users /></RequirePage>} />
          <Route path="automations" element={<RequirePage page="automations"><Automations /></RequirePage>} />
          <Route path="integrations" element={<RequirePage page="integrations"><Integrations /></RequirePage>} />
          <Route path="templates/whatsapp" element={<RequirePage page="templates"><WhatsAppTemplates /></RequirePage>} />
          <Route path="tags" element={<Tags />} />
          <Route path="ai-agents" element={<AiAgents />} />
          <Route path="orders" element={<RequireAnyPage pages={['orders', 'wip_orders', 'wip_production', 'wip_stock']}><Orders /></RequireAnyPage>} />
          <Route path="campaigns" element={<RequirePage page="campaigns"><Campaigns /></RequirePage>} />
          <Route path="shopify-app" element={<RequirePage page="integrations"><ShopifyApp /></RequirePage>} />
          <Route path="notifications" element={<RequirePage page="notifications"><Notifications /></RequirePage>} />
          <Route path="tickets" element={<RequirePage page="tickets"><Tickets /></RequirePage>} />
          <Route index element={<Navigate to="dashboard" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
